import {Component} from '@angular/core';
@Component({
  selector: 'nuc-terms',
  templateUrl: './terms.component.html',
  styles: [`.modal {
   background: rgba(0,0,0,0.6);
 }
 modal{
    display: block !important; /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog{
    overflow-y: initial !important
}
.modal-body{
    height: 60vh;
    overflow-y: auto;
}
`]
})
export class TermsComponent {

  public visible = false;
  public visibleAnimate = false;

  public open(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/terms/terms.component.ts